import { useParams } from 'react-router-dom';
import { ProjectId, ProjectConversationId } from 'api/models';

export const useProjectConvParams = (): [
  ProjectId | undefined,
  ProjectConversationId | undefined,
] => {
  const { projectId: projectIdFromRoute, chatId: chatIdFromRoute } =
    useParams<{ projectId: string; chatId: string }>();
  const projectId = projectIdFromRoute
    ? ProjectId(Number(projectIdFromRoute))
    : undefined;
  const chatId = chatIdFromRoute
    ? ProjectConversationId(Number(chatIdFromRoute))
    : undefined;

  return [projectId, chatId];
};
